import { init } from '@sentry/angular';
import { environment } from '../environments/environment';

export function initSentry() {
  init({
    dsn: environment.sentry.dsn,
    tracesSampleRate: environment.sentry.tracesSampleRate,
    environment: environment.sentry.environment,
    // Enable session replay (optional)
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    // Add integrations for better error tracking
    integrations: [
      // Browser integrations will be automatically added
    ],
    // Send default PII (personally identifiable information)
    sendDefaultPii: false,
    // Maximum breadcrumbs
    maxBreadcrumbs: 100,
    // Better error filtering
    beforeSend(event) {
      // Filter out noisy errors
      if (event.exception) {
        const error = event.exception.values?.[0];
        if (error?.type === 'ChunkLoadError' || 
            error?.type === 'ResizeObserver loop limit exceeded') {
          return null; // Don't send these common but harmless errors
        }
      }
      return event;
    },
  });
} 